import React from 'react';
import styled from 'styled-components';


/*

Props:


*/

const StyledButton = styled.button`
  /* display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: center; */
  border-color: none;
  border: none;
  border-width: 0px;
  background: none;
  /* color: red; */
  /* margin-right: 10px; */
  font-size: 16px;
  letter-spacing: 0.02em;
  font-weight: 100;
`;

const IconButton = ({ style, onClick, children }) => (
  <StyledButton style = {style}  onClick = {onClick}>
      { children }
  </StyledButton>
)

export default IconButton


// WEBPACK FOOTER //
// ./src/js/components/Button/IconButton.jsx